import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError, of, BehaviorSubject, interval } from 'rxjs';
import { LoginService } from './login.service';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private isRefreshedTrigger = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private userService: LoginService,
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.addLng(request);
    if (!request.url.endsWith('auth/login/credentials') && !request.url.endsWith('auth/signup/credentials')) {

      if (!this.isRefreshedTrigger && this.userService.getJwtToken()) {

        const token = JSON.parse(localStorage.getItem("token_info"));

        if (token.expires) {
          interval(this.getMicroSecs(token.expires - 60)).pipe(
            switchMap(() => {
              if (this.userService.getJwtToken()) return this.userService.refreshToken();
            })
          ).subscribe();
          this.isRefreshedTrigger = true;
        }
      }

      if (this.userService.getJwtToken() && !request.url.includes('public')) {
        request = this.addToken(request, this.userService.getJwtToken());
      }

      //return next.handle(proxyReq);
      return next.handle(request).pipe(
        catchError((event) => {
          if ((event instanceof HttpErrorResponse) && (event.status === 403 || event.status === 401)) {

            if (event.status === 401) {
              // return throwError(event);
              return this.handle401Error(request, next);
            }
            if (!request.url.endsWith('member/project_dictionary') && !request.url.endsWith('signup/verify_account')) {
              const token = JSON.parse(localStorage.getItem('token_info'));
              if (token) this.userService.logout();
              this.router.navigate(['/', 'login']);
              this.modalService.dismissAll();
              // window.location.replace('/login');
            }

          }

          if ((event instanceof HttpErrorResponse) && (event.status === 400 && event.url.endsWith('token/refresh'))) {
            const currentLang = localStorage.getItem('user_lng')
            localStorage.clear();
            localStorage.setItem('user_lng',currentLang)
            this.router.navigate(['/', 'login']);
            this.modalService.dismissAll();
          }
          return throwError(event);
        })
      );
    } else {
      return next.handle(request);
    }
  }

  private addLng(request: HttpRequest<any>) {
    let lng = this.translate.currentLang || 'en';
    lng = lng.slice(0, 2).toLocaleLowerCase();
    return request.clone({
      setHeaders: {
        "Accept-Language": lng
      }
    });
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }

  getMicroSecs(sec: number) {
    return sec * 1000;
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.userService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.accessToken);
          return next.handle(this.addToken(request, token.accessToken));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
}
